export const digitalAssetErrors: any = {
  filenameUniq: 'Filename already exist',
  primaryPhotoUniq: 'Only one Photo-primary can be selected.',
};
